/**
 * Expands and HTMLElement height
 * @param {HTMLElement} element
 * @return {void}
 */
export default function collapse(element) {
    // get the height of the element's inner content, regardless of its actual size
    const sectionHeight = element.scrollHeight;
    // temporarily disable all css transitions
    const elementTransition = element.style.transition;
    element.style.transition = '';
    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            element.style.height = 0 + 'px';
        });
    });
    setTimeout(() => {
        element.setAttribute('hidden', '');
    }, 600);
    // mark the section as "currently collapsed"
    element.setAttribute('data-collapsed', 'true');
}
